export default "__VITE_ASSET__DJaKOOA0__"